export default "__VITE_ASSET__DjSpmcNp__"